<script setup>
import { onMounted, ref } from 'vue';

import { getBrowserTimeZone } from '@/utils/browserTimeZone.js';

const props = defineProps({
    name: {
        type: String,
        default: 'time_zone',
    },
});

const timeZone = ref('');

onMounted(() => {
    timeZone.value = getBrowserTimeZone();
});
</script>

<template>
    <input
        type="hidden"
        :name="props.name"
        :value="timeZone"
    >
</template>
